// GENERATED FILE - DO NOT EDIT. Source: FA-Licensing-Bridge/catalog (regenerate with: python scripts/catalog.py sync).
//
// Typed access to the public plan catalog projection (planCatalog.json). The
// website renders plan cards, prices, and the comparison matrix from this data
// only. It is informational: FileAgent and the licensing bridge enforce
// entitlements server-side from signed licenses.
import data from "./planCatalog.json";

export const CATALOG_VERSION = 2 as const;
export const CATALOG_HASH = "sha256:322cf2700526469fadfbc6bac4505ea47340668744cee7c8d0ac02d34a11a367" as const;
/** sha256 of planCatalog.json as generated (checked by npm run catalog:check). */
export const CATALOG_JSON_SHA256 = "957799c343859321a636a71060ac718da0603e1eb798e0a13f76bad0330a86ac" as const;

export type PlanId = "free" | "pro" | "business" | "enterprise";
export type BillingInterval = "monthly" | "annual";
export type PurchaseKind = "download" | "self_serve" | "contact_sales";

export interface CatalogPrice {
  kind: "fixed" | "custom";
  amountMinor?: number;
  display: string;
}

export interface CatalogLimit {
  kind: "count" | "unlimited" | "contract";
  value?: number;
  label?: string;
  display: string;
}

export interface CatalogPlan {
  id: PlanId;
  code: string;
  name: string;
  order: number;
  tagline: string;
  purchase: PurchaseKind;
  recommendation?: string;
  includesPlan?: PlanId;
  prices: Record<BillingInterval, CatalogPrice>;
  billing: { annualSavingsMinor?: number; annualSavingsMonths?: number };
  limits: Record<string, CatalogLimit>;
  features: string[];
  policies: Record<string, { value: string | string[]; display: string }>;
  highlights: string[];
}

export interface CatalogCell {
  value: boolean | string;
  display: string;
}

export interface CatalogRow {
  id: string;
  label: string;
  kind: "price" | "limit" | "features" | "policy";
  hint?: string;
  features?: string[];
  cells: Record<PlanId, CatalogCell>;
}

export interface CatalogGroup {
  id: string;
  title: string;
  rows: CatalogRow[];
}

export interface CatalogDefinition {
  id: string;
  term: string;
  text: string;
}

export interface PublicCatalog {
  catalogId: string;
  catalogVersion: number;
  catalogHash: string;
  currency: "USD";
  label: string;
  /** Oldest FileAgent release that can enforce these plans. */
  minimumAppVersion?: string;
  plans: CatalogPlan[];
  matrix: CatalogGroup[];
  features: { id: string; label: string; note?: string; minimumPlan?: PlanId }[];
  limits: { id: string; label: string; unitSingular: string; unitPlural: string }[];
  policies: { id: string; label: string; options: Record<string, { label: string; description?: string }> }[];
  definitions: CatalogDefinition[];
}

export const planCatalog = (data as unknown as { catalog: PublicCatalog }).catalog;
